import React from "react";
import { cn } from "../../utils/cn";

const ClickableLinkEmbeddedText = ({
  fullText = "",
  linkedText = "",
  linkTarget = "#",
  textColor = "var(--color-content-01)",
  linkColor = "var(--color-secondary)",
  hoverEffect = "none",
  className = "",
  wrapperClassName = "",
  linkClassName = "",
  onClick,
  ...props
}) => {
  if (!fullText || !linkedText) return null;

  // Split fullText into parts to identify linkedText
  const parts = fullText.split(new RegExp(`(${linkedText})`, "gi"));

  return (
    <div
      className={cn("w-full h-full flex items-center", wrapperClassName)}
      style={{ width: "100%", height: "100%", fontSize: "1em" }} // responsive scaling
      {...props}
    >
      <p
        className={cn("font-inter", className)}
        style={{ color: textColor }}
      >
        {parts.map((part, index) =>
          part.toLowerCase() === linkedText.toLowerCase() ? (
            <a
              key={index}
              href={linkTarget}
              onClick={onClick}
              className={cn(
                "cursor-pointer transition-all duration-200",
                hoverEffect !== "none" && hoverEffect,
                linkClassName
              )}
              style={{ color: linkColor }}
            >
              {part}
            </a>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
      </p>
    </div>
  );
};

export default ClickableLinkEmbeddedText;
